export {
  PLUGIN_KEY,
  PLUGIN_PRIORITY,
  MergeCells,
} from './mergeCells';
